import {
  DeleteFile,
  GetFilesByReferences,
  SimplifiedUploadedFile,
  UploadedFile,
  UploadFile
} from "../../Models/UploadedFile";
import api from "../axios";

export const fileUploadService = {
  getByReferenceIds: async (data: GetFilesByReferences): Promise<UploadedFile[]> => {
    const response = await api.post("/file-upload/by-references", data);
    return response.data;
  },

  uploadFile: async (data: UploadFile): Promise<SimplifiedUploadedFile> => {
    const formData = new FormData();
    formData.append("File", data.file);
    formData.append("Context", data.context);
    formData.append("Purpose", data.purpose);
    
    if (data.referenceId) {
      formData.append("ReferenceId", data.referenceId);
    }

    const response = await api.post("/file-upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  deleteFile: async (data: DeleteFile): Promise<boolean> => {
    const response = await api.post("/file-upload/delete", data);
    return response.data;
  }
}
